var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "jImportFile jTableReport" },
    [
      _c("v-client-table", {
        staticClass: "jTable",
        attrs: {
          data: _vm.tableData,
          options: _vm.options,
          columns: _vm.columns
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "float-to-right" },
        [
          _vm._t("default"),
          _vm._v(" "),
          _c(
            "b-button",
            {
              staticClass: "btn blue",
              attrs: { disabled: _vm.disabled },
              on: { click: _vm.importData }
            },
            [_vm._v("Import")]
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b677c06c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b677c06c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/import/jTablePreview.vue
// module id = null
// module chunks = 